<div [class.override]="storefrontId === 572">
  <h2>{{ 'REGISTER.registerYourAccount' | translate }}</h2>
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <div class="register-form">
      <!-- First Name -->
      <app-input
        name="First Name"
        type="text"
        [control]="registerForm.controls.first_name"
        label="{{ 'COMMON.firstName' | translate }}"
      ></app-input>

      <!-- Last Name -->
      <app-input
        name="Last Name"
        type="text"
        [control]="registerForm.controls.last_name"
        label="{{ 'COMMON.lastName' | translate }}"
      ></app-input>

      <!-- Email -->
      <app-input
        name="Email"
        type="email"
        [control]="registerForm.controls.email"
        label="{{ 'COMMON.emailAddress' | translate }}"
      ></app-input>

      <!-- Username -->
      <app-input
        name="Username"
        type="text"
        [control]="registerForm.controls.username"
        label="{{ 'COMMON.username' | translate }}"
      ></app-input>

      <!-- Password -->
      <div class="password-field">
        <label class="input-label" for="password">{{ 'COMMON.password' | translate }}</label>
        <p-password
          id="password"
          formControlName="password"
          [feedback]="true"
          [toggleMask]="true"
          [inputStyle]="{ width: '100%' }"
          [style]="{ width: '100%' }"
        >
          <ng-template #header>
            <h6>Pick a password</h6>
          </ng-template>
          <ng-template #footer>
            <p-divider></p-divider>
            <!--          <p class="mt-2">Suggestions</p>-->
            <div class="mt-0" style="line-height: 1.5">
              <div class="password-validation">
                <img [src]="'assets/img/icons/' + errorIcons.upperAndLower + '.svg'" alt="" />
                <p>At least one lowercase, uppercase and special character ($,&,"&#64;",?...)</p>
              </div>
              <div class="password-validation">
                <img [src]="'assets/img/icons/' + errorIcons.number + '.svg'" alt="" />
                <p>At least one numeric</p>
              </div>
              <div class="password-validation">
                <img [src]="'assets/img/icons/' + errorIcons.minLength + '.svg'" alt="" />
                <p>Minimum 8 characters</p>
              </div>
            </div>
          </ng-template>
        </p-password>
      </div>

      <!-- Confirm Password -->
      <div class="password-field">
        <label class="input-label" for="password_confirmation">
          {{ 'COMMON.confirmPassword' | translate }}
        </label>
        <p-password
          id="password_confirmation"
          formControlName="password_confirmation"
          [feedback]="true"
          [toggleMask]="true"
          [ngClass]="{
            'ng-dirty': confirmPassword?.dirty,
            'ng-invalid': confirmPassword?.invalid && confirmPassword?.touched
          }"
          [inputStyle]="{ width: '100%' }"
          [style]="{ width: '100%' }"
        >
          <ng-template #footer>
            @if (
              (confirmPassword?.dirty || confirmPassword?.touched) &&
              registerForm.hasError('notMatched')
            ) {
              <div class="password-validation">
                <div>Passwords don't match</div>
              </div>
            }
          </ng-template>
        </p-password>
      </div>

      <!-- Register Button -->
      <div class="register">
        <app-button
          label="{{ 'REGISTER.register' | translate }}"
          type="submit"
          [disabled]="registerForm.invalid"
          [loading]="loading"
          [fullWidth]="true"
        ></app-button>
      </div>
    </div>
  </form>
</div>
